import React from 'react';

import * as Cell from '../common/Cell.jsx';
import { withHoverEffects } from '../common/Image.jsx';
import Name from '../common/Name.jsx';
import Token from '../common/Token.jsx';
import Url from '../common/Url.jsx';

function BlogCellContainer(props) {
    return <Cell.Container {...props} type="blog" useCellSpacer={false} />
}

// region BLOG IMAGE

function _BlogImageComponent(props) {
    const data = props.data || {};
    return (
        <Cell.Image
            {...props}
            className="blog__card__img"
            image={data.featured}
            imageData={{ alt: data.title, title: data.title }}
            link={Url.getLink('', `post/${data.blogId}`, { sub: props.querySub, layout: props.queryLayout, dataSub: props.queryDataSub }, props.builder)} />
    );
}
const BlogImageComponent = withHoverEffects(_BlogImageComponent, 'layout');
const BlogImage = { Component: BlogImageComponent };

// region BLOG META

function BlogMetaComponent(props) {
    const blogContent = props.data || {};
    const link = Url.getLink('', `post/${blogContent.blogId}`, { sub: props.querySub, layout: props.queryLayout, dataSub: props.queryDataSub }, props.builder);
    const handleTokenReplacement = (keyword, options) => Token.parsing.blogContent({ blogContent, link }, keyword, options);
    return <Cell.Meta {...props} onTokenReplacement={handleTokenReplacement} />
}
const BlogMetaTokens = () => {
    return [
        { display: 'Title', token: Token.Title },
        { display: 'Published Date', token: Token.Published },
        { display: 'Blog Excerpt', token: Token.Excerpt },
        {
            display: 'Link to Post',
            options: [{ display: 'Display Text', name: 'display' }],
            token: Token.BlogPostLink
        }
    ];
}
const BlogMeta = { Component: BlogMetaComponent, Tokens: BlogMetaTokens };

export {
    BlogCellContainer,
    BlogImage,
    BlogMeta
}
